import * as Yup from 'yup';

type Translate = (key: string) => string;

const prefix = 'USERSMANAGEMENU.THIRD_PARTY_ACCOUNT_MANAGEMENT';

const accountNameRule = (i18T: Translate) =>
  Yup.string()
    .max(40, i18T(`${prefix}.ACCOUNT_NAME_MAX_ERROR`))
    .required(i18T(`${prefix}.ACCOUNT_REQUIRED`));

const descriptionRule = (i18T: Translate) => Yup.string().max(128, i18T(`${prefix}.DESCRIPTION_MAX_ERROR`));

const availableDaysRule = (i18T: Translate) =>
  Yup.string()
    .required(i18T(`${prefix}.ACCOUNT_REQUIRED`))
    .matches(/^[1-9]\d*$/, i18T(`${prefix}.AVAILABLE_DAYS_FORMAT_ERROR`));

// 限制搜尋資料日期：皆為非必填，日數需為0以上的整數，結束時間不可早於起始時間
const searchLimitRules = (i18T: Translate) => ({
  searchLimitDays: Yup.string().matches(/^\d+$/, i18T(`${prefix}.SEARCH_LIMIT_DAYS_FORMAT_ERROR`)),
  searchStartDate: Yup.date().nullable(),
  searchEndDate: Yup.date()
    .nullable()
    .when('searchStartDate', (start: Date | null, schema: Yup.DateSchema<Date | null | undefined>) =>
      start ? schema.min(start, i18T(`${prefix}.SEARCH_DATE_RANGE_ERROR`)) : schema,
    ),
});

// 新增頁面：廠商帳號可輸入
export const createThirdPartyAccountSchema = (i18T: Translate) =>
  Yup.object().shape({
    account: Yup.string()
      .max(30, i18T(`${prefix}.ACCOUNT_MAX_ERROR`))
      .matches(/^[A-Za-z0-9_]*$/, i18T(`${prefix}.ACCOUNT_FORMAT_ERROR`))
      .required(i18T(`${prefix}.ACCOUNT_REQUIRED`)),
    accountName: accountNameRule(i18T),
    description: descriptionRule(i18T),
    availableDays: availableDaysRule(i18T),
    ...searchLimitRules(i18T),
  });

// 編輯頁面：廠商帳號不可編輯
export const editThirdPartyAccountSchema = (i18T: Translate) =>
  Yup.object().shape({
    accountName: accountNameRule(i18T),
    description: descriptionRule(i18T),
    availableDays: availableDaysRule(i18T),
    ...searchLimitRules(i18T),
  });
